import styled from '@emotion/styled';
import { colors, MagicStars, Text } from '@innovationdepartment/proxima-ui';
import TrialEndedPillView from 'ui/TrialEnded/TrialEnded.Pill.View';
import { getDaysRemaining } from 'utils/getDaysRemaining';

const GradientTag = styled.div`
  border-radius: 100px;
  background: linear-gradient(90deg, ${colors.proximaGreen40} 0%, #89d0e9 100%);
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 4px 8px;
  width: 67px;
`;

const HeaderContainer = styled.div`
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.neutral20};
  display: flex;
  height: 69px;
  padding: 12px 32px;
  justify-content: space-between;
  align-items: center;
`;

const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const HeaderRightSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;

  .trial-ended-pill {
    position: static;
  }
`;

const IconLabelContainer = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  > svg {
    height: 16px;
    width: 16px;
  }
`;

type InsightsHeaderProps = {
  title: string;
  trialEndDate: string;
  onOpenManageSubscriptionModal: () => void;
};

const TrendsHeader = (props: InsightsHeaderProps) => {
  const { title, trialEndDate, onOpenManageSubscriptionModal } = props;

  // Convert unix timestamp into a date
  const trialEndDateConverted = new Date(trialEndDate);

  const daysRemaining = getDaysRemaining(trialEndDateConverted);

  const showTrialEndingPill = daysRemaining <= 30 && daysRemaining > 0;

  return (
    <HeaderContainer>
      <HeaderTitle>
        <Text color="neutral90" variant="h4" isTermina>
          {title}
        </Text>
        <GradientTag>
          <IconLabelContainer>
            <MagicStars />
            <Text variant="tag2Semibold" color="neutral80">
              Beta
            </Text>
          </IconLabelContainer>
        </GradientTag>
      </HeaderTitle>
      <HeaderRightSection>
        {showTrialEndingPill && (
          <TrialEndedPillView
            daysRemaining={daysRemaining}
            onOpenManageSubscriptionModal={onOpenManageSubscriptionModal}
          />
        )}
      </HeaderRightSection>
    </HeaderContainer>
  );
};

export default TrendsHeader;
